<div class="point-map">
    <div class="point-map__container" #pointMapContainer></div>
</div>
